module.exports = __webpack_public_path__ + "img/6.543f73ec.jpg";